import { StyleSheet, View } from "react-native";

import { radii, useThemedStyles, type ThemeColors } from "~/styles/theme";

export function ProgressBar({
  value,
  label,
}: {
  value: number;
  label: string;
}) {
  const stylesheet = useThemedStyles(makeStyles);
  const normalizedValue = Math.min(100, Math.max(0, value));
  return (
    <View
      accessible
      accessibilityLabel={label}
      accessibilityRole="progressbar"
      accessibilityValue={{ min: 0, max: 100, now: normalizedValue }}
      style={stylesheet.track}
    >
      <View style={[stylesheet.bar, { width: `${normalizedValue}%` }]} />
    </View>
  );
}

const makeStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    track: {
      overflow: "hidden",
      width: "100%",
      height: 8,
      borderRadius: radii.pill,
      backgroundColor: colors.surface,
    },
    bar: {
      height: "100%",
      borderRadius: radii.pill,
      backgroundColor: colors.primary,
    },
  });
